import config from 'config';

export const getPreviewSrc = (filePath: string) => {
  const cleanPath = filePath.split('?')[0].toLowerCase();

  if (cleanPath.endsWith('.pdf')) {
    return require('../assets/img/pdficon.png');
  }

  if (cleanPath.endsWith('.doc') || cleanPath.endsWith('.docx')) {
    return require('../assets/img/docicon.png');
  }

  return `${config.baseUrl}/${filePath}`;
};

export const encodeFileName = (path: string) => {
  const parts = path.split('/');
  parts[parts.length - 1] = encodeURIComponent(parts.at(-1)!);
  return parts.join('/');
};
